/**
 * Honeypot Spam Protection
 * Adds invisible honeypot fields to forms to catch bots
 */

class SpamProtection {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.protectForms());
    } else {
      this.protectForms();
    }
  }

  protectForms() {
    // Target all forms on the page
    const forms = document.querySelectorAll('form');
    
    forms.forEach(form => {
      // Skip if already protected
      if (form.dataset.spamProtected) return;
      
      this.addHoneypot(form);
      form.dataset.spamProtected = 'true';
    });

    // Watch for dynamically added forms (like Shopify Forms app)
    this.observeNewForms();
  }

  addHoneypot(form) {
    // Create honeypot field (hidden from humans, visible to bots)
    const honeypot = document.createElement('div');
    honeypot.style.position = 'absolute';
    honeypot.style.left = '-9999px';
    honeypot.style.width = '1px';
    honeypot.style.height = '1px';
    honeypot.style.overflow = 'hidden';
    honeypot.setAttribute('aria-hidden', 'true');
    honeypot.setAttribute('tabindex', '-1');
    
    honeypot.innerHTML = `
      <label for="website_url_${this.generateId()}">Leave this field blank</label>
      <input type="text" name="website_url" id="website_url_${this.generateId()}" value="" autocomplete="off" tabindex="-1">
    `;
    
    // Insert at the beginning of the form
    form.insertBefore(honeypot, form.firstChild);
    
    // Add submit handler
    form.addEventListener('submit', (e) => this.validateForm(e, form));
  }

  validateForm(event, form) {
    const honeypotField = form.querySelector('input[name="website_url"]');
    
    // If honeypot is filled, it's likely a bot
    if (honeypotField && honeypotField.value !== '') {
      event.preventDefault();
      console.warn('Spam detected - form submission blocked');
      
      // Optionally show a message (silent by default)
      // alert('There was an error submitting the form. Please try again.');
      
      return false;
    }
    
    return true;
  }

  observeNewForms() {
    // Watch for dynamically added forms
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Check if the node itself is a form
            if (node.tagName === 'FORM' && !node.dataset.spamProtected) {
              this.addHoneypot(node);
              node.dataset.spamProtected = 'true';
            }
            // Check for forms within the added node
            const forms = node.querySelectorAll?.('form');
            forms?.forEach(form => {
              if (!form.dataset.spamProtected) {
                this.addHoneypot(form);
                form.dataset.spamProtected = 'true';
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  generateId() {
    return Math.random().toString(36).substr(2, 9);
  }
}

// Initialize spam protection
new SpamProtection();
